import { mapGetters, mapState } from 'vuex';

import WindowM from './WindowM.js';
import DoorM  from './DoorM.js';

export default {
  data() {
    return {
    }
  },
	mixins: [WindowM, DoorM],
  computed: {
    ...mapGetters([
      'avalibl_parts_for_grid',
    ]),
  },
}
